import { Icon } from "../../../components/icons";
import { BRAND_ITEMS } from "../content";
import { BrandComposite } from "../mockups/BrandComposite";
import "./BrandSection.css";

/** Tu marca (#marca): convocatoria, cuadro impreso, credencial y
 * patrocinadores con el logo del club, junto a la maqueta M11. */
export function BrandSection() {
  return (
    <section id="marca" className="t123-section t123-marca" aria-labelledby="t123-marca-title">
      <div className="t123-shell t123-marca__grid">
        <div className="t123-marca__copy">
          <span className="t123-kicker">Tu marca</span>
          <h2 id="t123-marca-title" className="t123-h2">
            Tu club, con su logo, en lo que ven tus jugadores
          </h2>
          <ul className="t123-marca__list">
            {BRAND_ITEMS.map((item) => (
              <li key={item.title} className="t123-marca__item">
                <span className="t123-tile-icon" aria-hidden="true">
                  <Icon name={item.icon} />
                </span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.copy}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="t123-marca__mock">
          <BrandComposite />
        </div>
      </div>
    </section>
  );
}
